import { Badge, type BadgeVariant } from '@/components/ui';
import type { Lifecycle } from '@/data/types';

export const LIFECYCLE_LABEL: Record<Lifecycle, string> = {
  prospect: 'Prospect', lead: 'Lead', client: 'Client', past_client: 'Past client',
};
const VARIANT: Record<Lifecycle, BadgeVariant> = {
  prospect: 'neutral', lead: 'accent', client: 'success', past_client: 'outline',
};
export const LIFECYCLE_OPTIONS = (Object.keys(LIFECYCLE_LABEL) as Lifecycle[]).map((value) => ({ value, label: LIFECYCLE_LABEL[value] }));

export function LifecycleBadge({ lifecycle }: { lifecycle: Lifecycle }) {
  return <Badge variant={VARIANT[lifecycle]}>{LIFECYCLE_LABEL[lifecycle]}</Badge>;
}
